import React from 'react';
import bgImg from '../assets/images/ME_Jacob_Diaz.webp';

const BannerRight = () => {
  return (
    <div
      className="w-1/2 min-h-screen bg-cover bg-no-repeat relative z-0 hidden lg:block"
      style={{
        backgroundImage: `url(${bgImg})`
      }}></div>
  );
};

export default BannerRight;
